import React from 'react';
import RegisterGuest from '../../views/RegisterGuest';
import { customerRegistration, requestPlatformAccess } from '../Authentication/RegisterActions';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { toast } from 'react-toastify';

class RegisterGuestContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    console.log(data);
    /* begin TECHNICAL DEBT */
    data.domain = "calhountrucklines";
    /* end   TECHNICAL DEBT */
    const { dispatchRequestPlatformAccess } = this.props;
    dispatchRequestPlatformAccess({ requestAccessBody: data}, (err, data)=>{    
      if(err){
        toast.error(err.message);
      }      
    });
  }

  render() {
    const {platformAccess} = this.props;
    let success = false;
    let errorText = false;

    if (platformAccess.get('signupSuccess')) {
      success=platformAccess.get('signupSuccess') ; 
    }
    if (platformAccess.get('error')) {
      errorText=platformAccess.get('error').message ; 
    }
    return <RegisterGuest errorText={errorText} success={success} onSubmit={this.handleSubmit}  platformAccess={platformAccess}/>;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchRequestPlatformAccess: (data, cb) => dispatch(requestPlatformAccess(data, cb))
  };
}

function mapStateToProps(state) {
  return {
    platformAccess: state.platformAccess
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterGuestContainer);


// WEBPACK FOOTER //
// ./src/containers/Register/RegisterGuestContainer.js